var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgDeposit(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#BCD194",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.594 10l-14.808 2.26a3.445 3.445 0 00-1.994 1.169A3.389 3.389 0 009 15.587v10.112a2.37 2.37 0 00.79 1.91 2.417 2.417 0 001.996.59l14.808-2.216a3.465 3.465 0 001.991-1.177 3.41 3.41 0 00.795-2.158V12.521a2.364 2.364 0 00-.777-1.929A2.41 2.41 0 0026.594 10z",
    fill: "#B37951"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.393 11.714L13.56 12.906c-1.43.123-2.595 1.162-2.595 2.332v7.33c0 1.162 1.165 2.005 2.595 1.882l13.833-1.206c1.43-.124 2.595-1.17 2.595-2.332v-7.323c0-1.163-1.195-1.998-2.595-1.875z",
    fill: "#9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.994 13.734H12.006a3.02 3.02 0 00-2.123.87A2.965 2.965 0 009 16.705v10.316c.002.79.32 1.546.882 2.104a3.027 3.027 0 002.124.875h15.988a3.027 3.027 0 002.123-.875c.564-.558.881-1.314.883-2.104V16.705a2.965 2.965 0 00-.883-2.101 3.02 3.02 0 00-2.123-.87z",
    fill: "#F2AB79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.24 13.734L9 21.551v-5.085a2.71 2.71 0 01.81-1.934 2.759 2.759 0 011.954-.798H24.24z",
    fill: "#FCC197"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.996 18.296H13.48c-1.012 0-1.635 1.94-.667 2.74l5.762 4.554a2.285 2.285 0 002.844 0l5.77-4.555c.901-.726.403-2.739-.667-2.739h-6.525z",
    fill: "#B37951"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.996 19.32H13.48c-.221.001-.438.07-.618.197a1.062 1.062 0 00-.409 1.157c.061.211.187.398.36.536l5.762 4.555a2.286 2.286 0 002.845 0l5.769-4.555a1.06 1.06 0 00.341-1.179 1.061 1.061 0 00-.39-.514 1.078 1.078 0 00-.618-.196h-6.525z",
    fill: "#9F9"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 10)",
    d: "M0 0h22v20H0z"
  })))));
}
export default SvgDeposit;